module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container-new right-info-block",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "order-instruction-header mb-10"
  }, [_c('i', {
    staticClass: "ion-android-locate header-icon"
  }), _vm._v(" "), _c('h2', [_vm._v("Wybrany punkt podjęcia")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "290px"
    },
    attrs: {
      "id": "first-step-map"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42d79e00","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FirstStepMap.vue
// module id = 249
// module chunks = 1